import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { RouteNames } from "../../navigation/RouteNames";
import { useAppSelector } from "../../store/hooks";
import { useTranslation } from "../../translations/i18n";
import { isCustomSubscription } from "../../utils/helperFunctions/subscriptionAccessHelper";

interface UpgradeRequiredModalProps {
  open: boolean;
  title?: string;
  message: string;
  onClose: () => void;
}

const UpgradeRequiredModal = ({
  open,
  title,
  message,
  onClose,
}: UpgradeRequiredModalProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { account } = useAppSelector((state) => state.auth);

  const customSubscription = isCustomSubscription(account);

  const goToSubscriptionAction = () => {
    onClose();

    navigate(customSubscription ? RouteNames.support : RouteNames.subscription);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle
        sx={{
          fontWeight: 900,
        }}
      >
        {title || t("subscription.upgradeRequired")}
      </DialogTitle>

      <DialogContent>
        <Box sx={{ pt: 1 }}>
          <Typography color="text.secondary">{message}</Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} variant="outlined">
          {t("subscription.noticeCloseCta")}
        </Button>

        <Button onClick={goToSubscriptionAction} variant="contained">
          {t(
            customSubscription
              ? "subscription.contactSupportCta"
              : "subscription.viewPlansCta",
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpgradeRequiredModal;
